// composables/useFileTypeDetection.ts - 文件类型检测与路由映射（无副作用）

export type Category = 'pdf' | 'office' | 'ebook' | 'subtitle'

const EXT_MAP: Record<Category, string[]> = {
  pdf: ['pdf'],
  office: ['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx'],
  ebook: ['epub', 'mobi', 'azw', 'azw3'],
  subtitle: ['srt', 'vtt', 'ass', 'ssa']
}

const CATEGORY_PATH: Record<Category, string> = {
  pdf: '/translate-pdf',
  office: '/translate-office',
  ebook: '/translate-ebook',
  subtitle: '/translate-subtitle'
}

export function useFileTypeDetection() {
  const normalizeExt = (name: string): string => {
    const ext = name.split('.').pop() || ''
    return ext.toLowerCase()
  }

  const detectCategoryByExt = (fileName: string): Category | null => {
    const ext = normalizeExt(fileName)
    if (!ext) return null
    for (const [cat, list] of Object.entries(EXT_MAP) as [Category, string[]][]) {
      if (list.includes(ext)) return cat
    }
    return null
  }

  const categoryToPath = (category: Category): string => {
    // 预留 i18n：未来可替换为 useLocalePath()(CATEGORY_PATH[category])
    return CATEGORY_PATH[category]
  }

  const allowedExtensionsForCategory = (category?: string): string[] => {
    switch ((category || '').toLowerCase()) {
      case 'pdf':
        return EXT_MAP.pdf
      case 'office':
        return EXT_MAP.office
      case 'ebook':
        return EXT_MAP.ebook
      case 'subtitle':
        return EXT_MAP.subtitle
      default:
        // 通用页或未知：不限制，由父层自行控制
        return []
    }
  }

  const acceptForCategory = (category?: string): string => {
    const list = allowedExtensionsForCategory(category)
    if (!list.length) {
      // 全量 accept（与现有组件默认一致）
      return '.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.epub,.mobi,.azw,.azw3,.srt,.ass,.ssa,.vtt'
    }
    return list.map((x) => `.${x}`).join(',')
  }

  return {
    detectCategoryByExt,
    categoryToPath,
    allowedExtensionsForCategory,
    acceptForCategory
  }
}

